import { render, staticRenderFns } from "./tickets-data.vue?vue&type=template&id=63a13fbf&scoped=true&"
import script from "./tickets-data.vue?vue&type=script&lang=js&"
export * from "./tickets-data.vue?vue&type=script&lang=js&"
import style0 from "./tickets-data.vue?vue&type=style&index=0&id=63a13fbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a13fbf",
  null
  
)

export default component.exports